export enum ISegmentTypeEnum {
  ESTATE_WORKPLACES_REAAS = 'ESTATE_WORKPLACES_REAAS',
  ESTATE_WORKPLACES_BTR = 'ESTATE_WORKPLACES_BTR',
  ESTATE_RESIDENTIAL_REAAS = 'ESTATE_RESIDENTIAL_REAAS',
  ESTATE_RESIDENTIAL_BTR = 'ESTATE_RESIDENTIAL_BTR',
  ESTATE_RESIDENTIAL_BTS = 'ESTATE_RESIDENTIAL_BTS',
  ESTATE_EDUCATION = 'ESTATE_EDUCATION',
  ESTATE_SPORT_FACILITIES = 'ESTATE_SPORT_FACILITIES',
  ESTATE_MUNICIPALITIES = 'ESTATE_MUNICIPALITIES',
  ESTATE_HEALTHCARE = 'ESTATE_HEALTHCARE',
  ESTATE_RETAIL_MULTI_SITE = 'ESTATE_RETAIL_MULTI_SITE',
  ESTATE_HOSPITALITY_PROFESSIONAL = 'ESTATE_HOSPITALITY_PROFESSIONAL',
  ESTATE_HOSPITALITY_SMALL = 'ESTATE_HOSPITALITY_SMALL',
  UTILITIES_TELECOM = 'UTILITIES_TELECOM',
  UTILITIES_ELECTRICITY = 'UTILITIES_ELECTRICITY',
  'UTILITIES_OIL&GAS' = 'UTILITIES_OIL&GAS',
  UTILITIES_WATER = 'UTILITIES_WATER',
  UTILITIES_WASTE = 'UTILITIES_WASTE',
  UTILITIES_TRANSPORTATION = 'UTILITIES_TRANSPORTATION',
  DEMO = 'DEMO',
  // OLD VALUES BELOW -> see "isSegmentTypeDeprecated"
  WORKING_SPACES = 'WORKING_SPACES',
  LIVING = 'LIVING',
  RETAIL = 'RETAIL',
  UNIVERSITIES = 'UNIVERSITIES',
  LEISURE = 'LEISURE',
  HOSPITAL = 'HOSPITAL',
}
